import React from "react";
import Routing from "router";
import "react-quill/dist/quill.snow.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-day-picker/dist/style.css";
import "assets/sass/index.scss";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Inspection from "./pages/inspection";

function App() {
    const { t } = useTranslation();
    // const [startDay, setStartDay] = useState();
    // const [endDay, setEndDay] = useState();
    // const [nowDay, setNowDay] = useState();
    const [isEvent, setIsEvent] = useState(false); // event banner

    const getDay = () => {
        // 2022s년 2월 13일 월은 0부터 시작하므로 2월은 1
        const start_day = new Date(2023, 5, 3, 11, 0, 0); // 이벤트 시작 시간
        const d_day = new Date(2023, 5, 3, 16, 0, 0); // 이벤트 종료 시간

        let date = new Date();

        // utc 시간 -540(분)
        const utc = date.getTime() + date.getTimezoneOffset() * 60 * 1000;
        // // 9시간 보정
        const kr_time_diff = 9 * 60 * 60 * 1000;
        // // 대한민국 표준시
        const current_kr_time = new Date(utc + kr_time_diff);

        const d_day_m = d_day.getTime();
        const start_day_m = start_day.getTime();

        const current_kr_time_m = current_kr_time.getTime();

        // setStartDay(
        //     `${start_day.getMonth() + 1}월 ${start_day.getDate()}일 ${start_day.getHours()}:${start_day.getMinutes()}:${start_day.getSeconds()}`
        // );
        // setEndDay(`${d_day.getMonth() + 1}월 ${d_day.getDate()}일 ${d_day.getHours()}:${d_day.getMinutes()}:${d_day.getSeconds()}`);
        // setNowDay(
        //     `${
        //         current_kr_time.getMonth() + 1
        //     }월 ${current_kr_time.getDate()}일 ${current_kr_time.getHours()}:${current_kr_time.getMinutes()}:${current_kr_time.getSeconds()}`
        // );

        let distance = start_day_m <= current_kr_time_m && current_kr_time_m < d_day_m;

        if (distance) {
            // event 기간 중
            setIsEvent(true);
        } else {
            // event 기간 끝
            setIsEvent(false);
        }
    };

    useEffect(() => {
        getDay();
    }, []);

    return (
        <>
            {isEvent ? (
                <>
                    <Inspection />
                </>
            ) : (
                <Routing />
            )}
        </>
    );
}

export default App;
